import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { isMobile, login, jumpPageUrl } from '@src/common/util';
import { getHeaderHeight, getHostIndex, getHotList, goNewPage, submitApi } from '@src/mobile/request';
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/dynamic';
import auth, { LoginDialog } from '@ifeng-fe/ui_pc_auth';
import { ResultUrl, ListUrl, shadow, indexCommentConfig, qqShareCofig } from '@src/constants/index';
import Card from './card';

const Layout = ({ content }) => {
    const { commentData = {} } = content;
    const { vote, voteItem } = commentData;
    let { name, voteItem: voteItemP } = vote;

    voteItemP = voteItemP.map(item => {
        return {
            ...item,
            isHot: item.isHot === '1',
        };
    });
    const [isEnd, setIsEnd] = useState(false);
    const [commentArray, setComment] = useState([]);
    const [text, setText] = useState('');
    const [showModel, setShowModel] = useState(false);
    const [modeText, setModeText] = useState('');
    const [listData, setListData] = useState([]);
    const userInfo = auth.isLogin() ? auth.getUserInfo() : null;

    const [flag, setFlag] = useState('1'); // 1是没登录点击分类 2是点击提交评论
    const [voteId, setVoteId] = useState('');
    const [loginId, setLoginId] = useState('');

    const getCommentData = async () => {
        const { comments = [] } = await getHotList(indexCommentConfig.docUrl);

        setComment(comments);
    };

    const getAllResult = async () => {
        const hotData = await getHostIndex();
        let { isEnd, industries = voteItem } = hotData || {};

        industries = industries.filter((item) => item.title !== vote.name);
        setIsEnd(isEnd);
        setListData(industries);
    };

    const checkStatus = async (voteId) => {
        try {
            if (isEnd) {
                goNewPage(`${ResultUrl}?name=${encodeURIComponent(voteId)}`);
            } else {
                goNewPage(`${ListUrl}?name=${encodeURIComponent(voteId)}`);
            }
        } catch (e) {
            goNewPage(`${ListUrl}?name=${encodeURIComponent(voteId)}`);
            console.log(e);
        }
    };

    const changeText = (text) => {
        setText(text);
    };
    const submitComment = async () => {
        const res = await submitApi({ content: text, ...indexCommentConfig });
        const { code, message } = res;

        console.log(res);
        if (code === 117) {
            if (isMobile() || window.grounds) {
                window.grounds.userLogin();
            } else {
                // pc端拉起实名窗口
                auth.login(loginId);
            }
        } else if (code === 115) {
            if (!isMobile() && !window.grounds) {
                auth.login(loginId);
            }
        } else {
            setModeText(decodeURIComponent(message ? message : '评论成功'));
            setShowModel(true);
            setTimeout(() => {
                setModeText('');
                setShowModel(false);
            }, 3000);
        }
        setText('');
    };
    const submit = async () => {
        setFlag('2');
        if (login({ pcLogin: true, loginId })) {
            submitComment();
        }
    };

    const goResult = async (voteId) => {
        setVoteId(voteId);
        if (isEnd) {
            // 跳转到结果页
            goNewPage(`${ResultUrl}?name=${encodeURIComponent(voteId)}`);
        } else {
            const loginFlat = await login({ pcLogin: true, loginId });

            // 进入投票详情页面一定是登录状态
            if (loginFlat) {
                checkStatus(voteId);
            }
        }
    };

    useEffect(() => {
        console.log(flag, voteId);
        const unBindLogin = auth.event.on(auth.EVENTNAMES.login, (userInfo) => {
            console.log('登录成功', flag, voteId);
            window.localStorage.setItem('token', userInfo.sid);
            if (flag === '1') {
                // 跳转具体分类
                checkStatus(voteId);
            } else {
                // 提交评论
                // submitComment();
            }
        });

        return () => {
            unBindLogin();
        };
    }, [flag, voteId]);

    useEffect(() => {
        const loginId = auth.uuid();

        setLoginId(loginId);
        try {
            getAllResult();
        } catch (e) {
            console.log(e);
        }
        // 客户端和移动端需要先登录
        login({ pcLogin: false });

        try {
            getCommentData();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
        }
        getHeaderHeight();
    }, []);

    return (
        <div>
            <div className={styles.layout_test}>
                <div className={styles.box} />
                <div className={styles.contentbox}>
                    {name ? (
                        <div className={styles.container}>
                            <div className={styles.contentBox}>
                                <div className={styles.contentHeader}>请您为{name}打分</div>
                                {voteItemP.map((item, index) => {
                                    return <Card index={index} item={item} key={index} length={voteItemP.length} goResult={goResult} id={name} />;
                                })}
                            </div>
                            <div
                                className={styles.morebtn}
                                onClick={() => {
                                    goResult(name);
                                }}>
                                <span>点击进入投票</span>
                            </div>
                        </div>
                    ) : null}

                    <div className={styles.content}>
                        <div className={styles.contentHeader}>请您为其他行业打分</div>
                        {listData.map((item, index) => {
                            return <Card index={index} item={item} key={index} length={listData.length} goResult={goResult} id={item.title} />;
                        })}
                    </div>
                </div>
                {/* 热门评论 */}
                <div>
                    <div className={styles.comment}>热门评论</div>

                    <div>
                        {commentArray?.length > 0 &&
                            commentArray.map((item, index) => {
                                return (
                                    <div key={index} className={styles.commentText}>
                                        {item.comment_contents}
                                    </div>
                                );
                            })}
                    </div>
                    <div className={styles.textareBox}>
                        <textarea
                            value={text}
                            onChange={(e) => {
                                changeText(e.target.value);
                            }}
                            placeholder=" 你有什么想说的..."
                            className={styles.textare}
                        />
                        <div className={styles.textareImg} onClick={submit}>
                            提交
                        </div>
                    </div>

                    <div />
                </div>
                <div className={styles.bottomImg} />
            </div>
            {showModel && <div className={styles.model}>{modeText}</div>}
            <QQShare isHitBlack={true} content={qqShareCofig} />
            <LoginDialog id={loginId} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
